/* Copyright Verge Technologies 2018
 * @file specials.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
//import React from 'react';
import React, { Component } from 'react';


import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CAREERS_QUERY } from '../../graphql';
import { CONTENT_QUERY } from '../../graphql';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import RequestCareerModal from '../../components/RequestCareerModal/requestCareerModal';
import ThankYouModal from '../../components/ThankYouModal/thankyou.modal';

//import React from 'react';
import { Link } from 'react-router-dom';

//const Careers = (props) => {
class Careers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoModalOpen: false,
      thankYouModalOpen: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {

  return (
    <div>
      <Header crumbs={this.props.crumbs} />
      <RequestCareerModal
          isOpen={this.state.infoModalOpen}
          closeModal={() => this.setState({ ...this.state, infoModalOpen: false })}
          openThankYouModal={() => this.setState({ ...this.state, infoModalOpen: false, thankYouModalOpen: true })}
        />
        <ThankYouModal
          isOpen={this.state.thankYouModalOpen}
          closeModal={() => {
            this.setState({ ...this.state, thankYouModalOpen: false });
          }}
        />

      
      <div className="page-heading heading-specials">Careers</div>


<Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "careers" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div>
<div dangerouslySetInnerHTML={{__html: data.getContent ? data.getContent.body : ""}} />
            </div>
          );
        }}
      </Query>

          <div className="text-center" style={{textAlign:"center"}}>
                          <p></p>
                          <a
                            onClick={() => {
                              this.setState({ infoModalOpen: true });
                            }}
                            className="button button-green"
                          >
                            Submit CV
                          </a>
          </div>



      <Query query={CAREERS_QUERY} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }


          return (
            <div>
            { (data.getCareers.length === 0) ?
              <div className="text-center" style={{textAlign:"center"}} >
                        <p></p>

                          <p>We have no vacancies at the moment, but we are always scouting spectacular talent. Please submit your CV to our database for possible future vacancies.</p>                            
                        
                        <p></p>
              </div>
              : null 
            }
            


            <div className="content-list-container special-list">

              <ul style={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}>
                {data.getCareers.map((special) => {
                  return (
                    <li>
                      <div className="image-block">

                        <img src={special.background_image} alt="special" />
                      </div>
                      <div className="content-block">
                        <h2>{special.title}</h2>
                        <p>
                          {special.short_description}
                        </p>
                      </div>
                      <div className="control">
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={special.link}
                          className="button button-green"
                        >
                          View details
                        </a>
                        &nbsp;
                      <a
                        onClick={() => {
                          this.setState({ infoModalOpen: true });
                        }}
                        className="button button-green"
                      >
                        Apply
                      </a>
                    </div>

                    </li>
                  );
                })}
              </ul>
            </div>
            </div>
          );
        }}
      </Query>
      <Footer />
    </div>
  );
};
};
export default Careers;



// WEBPACK FOOTER //
// ./src/pages/careers/careers.page.js